module.exports = __webpack_public_path__ + "static/media/mt.c2857112.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/mt.png
// module id = 1931
// module chunks = 0